/**
 * Sub-component of a <Dialog> component that displays a success message with a title and a close button.
 *
 * @component
 * @param {Object} props - The properties object.
 * @param {() => void} props.onClose - Function to call when the close button is clicked.
 * @param {string} props.title - The title to display in the success message.
 * @param {string} props.message - The message to display in the success message.
 * @returns {JSX.Element} The rendered Success component.
 */

import { makeStyles, Typography } from "@material-ui/core"
import clsx from "clsx"
import { FC } from "react"
import { PrimaryButton } from "../atoms/button/Button"
import { colors } from "../../utils/theme"

const Success: FC<{ onClose: () => void; title: string; message: string }> = ({
  onClose,
  title,
  message,
}) => {
  const classes = useStyles()
  return (
    <div className={classes.dialogContent}>
      <Typography
        variant="h2"
        className={clsx(classes.dialogTitle, classes.successText)}
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        className={clsx(classes.dialogSubtitle, classes.successText)}
      >
        {message}
      </Typography>
      <PrimaryButton
        onClick={onClose}
        className={classes.dialogButton}
        type="submit"
      >
        Close
      </PrimaryButton>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(2),
  },
  dialogTitle: {
    color: colors.neutral.denim,
    marginBottom: 12,
  },
  dialogSubtitle: {
    color: "#737373",
    marginBottom: theme.spacing(3),
  },
  dialogButton: {
    width: "100%",
  },
  successText: {
    textAlign: "center",
  },
}))

export default Success
